var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.9 19.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002d55;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.03,
    y: 9.62,
    width: 8.84,
    height: 0.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.43 14.97 6.96 14.5 11.51 9.95 6.96 5.41 7.43 4.94 12.44 9.95 7.43 14.97"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.84,
    y: 4.75,
    width: 0.66,
    height: 10.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.95,19.9C4.46,19.9,0,15.44,0,9.95S4.46,0,9.95,0s9.95,4.46,9.95,9.95-4.46,9.95-9.95,9.95ZM9.95,.66C4.83,.66,.66,4.83,.66,9.95s4.17,9.29,9.29,9.29,9.29-4.17,9.29-9.29S15.07,.66,9.95,.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaArrowLeft);
export default __webpack_public_path__ + "static/media/ctaArrowLeft.e2f2a311623c5b13dd28d2627a6b64b7.svg";
export { ForwardRef as ReactComponent };